var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illus_XXSml_96px_-_Something_went_wrong",
    "data-name": "Illus XXSml 96px  - Something went wrong",
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_4px_Padding",
    "data-name": "Container 4px Padding",
    width: 88,
    height: 88,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(3.667 7.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34339",
    "data-name": "Group 34339",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_157266",
    "data-name": "Path 157266",
    transform: "translate(-2.032 -3.054)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.524,70.887A3.672,3.672,0,0,0,5.645,76.4h73.44a3.672,3.672,0,0,0,3.121-5.508l-36.72-66.1a3.672,3.672,0,0,0-6.242,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.76878356933594 71.39506530761719 L 42.3652458190918 9.468701362609863 L 7.961709976196289 71.39506530761719 L 76.76878356933594 71.39506530761719 M 79.08515930175781 76.39506530761719 L 5.645330429077148 76.39506530761719 C 4.343976497650146 76.37429809570312 3.150853633880615 75.66622161865234 2.509176731109619 74.53388214111328 C 1.867515087127686 73.40154266357422 1.873207449913025 72.01411437988281 2.524130582809448 70.88707733154297 L 39.24405288696289 4.791219711303711 C 39.91360855102539 3.710850238800049 41.09423828125 3.053573369979858 42.36525344848633 3.053573369979858 C 43.63626861572266 3.053573369979858 44.81689834594727 3.710850238800049 45.4864387512207 4.791219711303711 L 82.20635986328125 70.88707733154297 C 82.85728454589844 72.01412963867188 82.86296081542969 73.40154266357422 82.22129821777344 74.53388214111328 C 81.57962036132812 75.66622161865234 80.38651275634766 76.37429809570312 79.08515930175781 76.39506530761719 Z",
    stroke: "none",
    fill: "#e54360"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_157267",
    "data-name": "Path 157267",
    d: "M22,20.672V37.2a3.672,3.672,0,1,0,7.344,0V20.672a3.672,3.672,0,1,0-7.344,0Z",
    transform: "translate(14.661 8.606)",
    fill: "#aa384b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3482",
    "data-name": "Ellipse 3482",
    cx: 3.672,
    cy: 3.672,
    r: 3.672,
    transform: "translate(36.661 53.146)",
    fill: "#aa384b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMobile);
export default __webpack_public_path__ + "static/media/error-mobile.11678dbca5e0d47a8c120003168fa6cf.svg";
export { ForwardRef as ReactComponent };